import React from "react";
import "../../assets/css/social.css";
import {Question} from "../Question";
import {Stream} from "../Stream";
import {useDispatch, useSelector} from "react-redux";
import {Launch} from "../Launch";
import {
    resetAnswers,
    setGenerating,
    setQnToSend,
    setSuggestedQuestions,
    setSummaryToTalk,
    setWaitingListModal,
    setWelcomeVideoPlay,
} from "../../store/reducers/questionReducer";
import {saveWaiting} from "../../services/api";
import {toast, ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {Chat} from "../Chat";
import {Scrollbars} from "react-custom-scrollbars-2";
import davidAvatarImage from "../../assets/images/david-avatarimg.png";
import willKnightAvatarImage from "../../assets/images/willknight-avatarimg.png";
import skyAvatarImage from "../../assets/images/sky-avatarimg.png";
import aaronAvatarImage from "../../assets/images/aaron-avatar.png";
import bridgetAvatarImage from "../../assets/images/bridget-avatar.png";
import allisonAvatarImage from "../../assets/images/allisonhorn-avatarimg.jpg";
import edoAvatarImage from "../../assets/images/edosegal-avatarimage.jpg";
import playBtn from "../../assets/images/playbtn.png";
import pauseBtn from "../../assets/images/pausebtn.png";
import ChatAnimation from "../ChatAnimation";
import userdata from "../../datas/userdata.json";
import paulGoldingAvatarImage from "../../assets/images/paul-golding-avatarimg.jpg";
import nicolasBaratteAvatarImage from "../../assets/images/nicolas-baratte-avatarimg.jpg";
import cherryMaAvatarImage from "../../assets/images/cherryma-avatarimg.jpg";
import smithCodioAvatarImage from "../../assets/images/smithcodio-avatarimg.jpg";
import frederickHavemeyerAvatarImage from "../../assets/images/frederick-havemeyer-avatarimg.jpg";
import rajivChandranAvatarImage from "../../assets/images/rajivchandran-avatarimg.jpg";
import jonGordonAvatarImage from "../../assets/images/jongordon-avatarimg.jpg";
import liorLavidAvatarImage from "../../assets/images/liorlavid-avatarimg.jpg";
import danaKochAvatarImage from "../../assets/images/danakoch-avatarimg.jpg";
import johnGoodyerAvatarImage from "../../assets/images/johngoodyer-avatarimg.jpg";
import simonHollandAvatarImage from "../../assets/images/simonholland-avatarimg.jpg";
import jessMajekodunmiAvatarImage from "../../assets/images/jessmajekodunmi-avatarimg.jpg";
import philipMoyerAvatarImage from "../../assets/images/philipmoyer-avatarimg.jpg";
import reidHoffmanAvatarImage from "../../assets/images/reidhoffman-avatarimg.jpg";
import drCamilleKandikoHowsonAvatarImage from "../../assets/images/drcamillekandikohowson-avatarimg.jpg";
import kathyChenAvatarImage from "../../assets/images/kathychen-avatarimg.jpg";
import tierneyMorganAvatarImage from "../../assets/images/tierneymorgan-avatarimg.jpg";
import bobGerardAvatarImage from "../../assets/images/bobgerard-avatarimg.jpg";


import ethanLawsonAvatarImage from "../../assets/images/ethan-lawson.png";
import sophiaMartinezAvatarImage from "../../assets/images/sophia-martinez.png";
import edoSegalAvatarImage from "../../assets/images/edosegal-avatarimage.jpg";
import johnSamuelAvatarImage from "../../assets/images/john-samuel.png";
import isabellaWongAvatarImage from "../../assets/images/isabella-wong.png";
import susanGoodyerAvatarImage from "../../assets/images/susangoodyer-avatarimg.jpg";
import bartClarysseAvatarImage from "../../assets/images/bart-clarysse-avatarimg.jpg";
import omarMerloAvatarImage from "../../assets/images/omar-merlo-avatarimg.jpg";
import markKennedyAvatarImage from "../../assets/images/mark-kennedy-avatarimg.jpg";



import {isAccentureTwin} from "../../helpers/util";

interface IProps {
    sendDataToSocket: (data: any) => void;
}

export const Social = (props: IProps) => {
    const dispatch = useDispatch();
    const {sendDataToSocket} = props;

    const [waitEmail, setWaitEmail] = React.useState<string>("");
    const [playIndex, setPlayIndex] = React.useState<null | number>(null);
    const [playing, setPlaying] = React.useState<boolean>(false);
    const [summary, setSummary] = React.useState<string>("");
    const [summaryId, setSummaryId] = React.useState<string | number>("");
    const [rightSidebarOpen, setRightSidebarOpen] =
        React.useState<boolean>(false);

    const chatAnswers = useSelector(
        (state: any) => state.questionReducer.chatAnswers
    );
    const streamData = useSelector(
        (state: any) => state.questionReducer.streamData
    );
    const showExperience = useSelector(
        (state: any) => state.questionReducer.showExperience
    );
    const openModel = useSelector(
        (state: any) => state.questionReducer.waitingListModal
    );
    const isChatMode = useSelector(
        (state: any) => state.questionReducer.isChatMode
    );
    const animationDOMRects = useSelector(
        (state: any) => state.questionReducer.animationDOMRects
    );
    const profilePath = useSelector(
        (state: any) => state.questionReducer.profilePath
    );
    const suggestedQuestions = useSelector(
        (state: any) => state.questionReducer.suggestedQuestions
    );
    const bio = useSelector(
        (state: any) => state.questionReducer.bio
    );
    const welcome = useSelector((state: any) => state.questionReducer.welcome);
    const name = useSelector((state: any) => state.questionReducer.name);
    const profileUsername = profilePath.replaceAll("-", "");

    const userDatas: any = userdata;
    const userDetails = userDatas[profileUsername]
        ? userDatas[profileUsername]
        : [];
    const posts = userDetails?.posts ? userDetails?.posts : [];

    const playBtnRef: any = React.createRef();
    const pauseBtnRef: any = React.createRef();
    let postVideoRefs: any = [];

    const closeLightbox = () => {
        setWaitEmail("");
        dispatch(setWaitingListModal(false));
    };
    const openLightbox = () => {
        dispatch(setWaitingListModal(true));
    };

    const submitWaitingList = async () => {
        if (waitEmail !== "") {
            const result = await saveWaiting({email: waitEmail});
            if (result.data.success) {
                toast.success("Success.", {
                    position: "top-center",
                    autoClose: 3000,
                });
                closeLightbox();
                setWaitEmail("");
            } else if (result.data.error == "Email already exists.") {
                toast.success(result.data.error, {
                    position: "top-center",
                    autoClose: 3000,
                });
                closeLightbox();
                setWaitEmail("");
            }
        }
    };
    const sendExampleQn = (qn: string) => {
        dispatch(setQnToSend(qn));
    };
    const closeVideo = () => {
        if (playIndex !== null) {
            playVideo(playIndex);
        }
    }
    const playVideo = (index: number) => {
        // stop previous
        const videoElPrev = (document as any).getElementById(
            "post-video-ref-" + playIndex
        );
        if (videoElPrev) {
            if (playing) {
                setPlaying(false);
                videoElPrev.currentTime = 0; //Reset to 0
                videoElPrev.pause();
                dispatch(setWelcomeVideoPlay(false));
            }
        }
        const videoEl = (document as any).getElementById(
            "post-video-ref-" + index
        );
        if (videoEl) {
            if (!playing || index !== playIndex) {

                setPlaying(true);
                videoEl.play();
                dispatch(setWelcomeVideoPlay(true));
            } else {

                setPlaying(false);
                videoEl.pause();
                dispatch(setWelcomeVideoPlay(false));
            }
        }
        setPlayIndex(index);
    };

    let emailCheck =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let image: any = (window as any).avatarImage
        ? (window as any).avatarImage
        : edoAvatarImage;
    if (profilePath === "david" || profilePath === "david-shrier") {
        image = davidAvatarImage;
    }
    if (profilePath === "will-knight") {
        image = willKnightAvatarImage;
    }
    if (profilePath === "sky") {
        image = skyAvatarImage;
    }
    if (profilePath === "bridgetrichards") {
        image = bridgetAvatarImage;
    }
    if (profilePath === "aaronrafferty") {
        image = aaronAvatarImage;
    }
    if (profilePath === "allisonhorn") {
        image = allisonAvatarImage;
    }
    if (profilePath === "paulgolding") {
        image = paulGoldingAvatarImage;
    }
    if (profilePath === "nicolasbaratte") {
        image = nicolasBaratteAvatarImage;
    }
    if (profilePath === "cherryma") {
        image = cherryMaAvatarImage;
    }
    if (profilePath === "frederickhavemeyer") {
        image = frederickHavemeyerAvatarImage;
    }
    if (profilePath === "rajivchandran") {
        image = rajivChandranAvatarImage;
    }
    if (profilePath === "smithcodio") {
        image = smithCodioAvatarImage;
    }
    if (profilePath === "jongordon") {
        image = jonGordonAvatarImage;
    }
    if (profilePath === "liorlavid") {
        image = liorLavidAvatarImage;
    }
    if (profilePath === 'danakoch') {
        image = danaKochAvatarImage;
    }
    if (profilePath === 'johngoodyer') {
        image = johnGoodyerAvatarImage;
    }
    if (profilePath === 'simonholland') {
        image = simonHollandAvatarImage;
    }
    if (profilePath === 'jessmajekodunmi') {
        image = jessMajekodunmiAvatarImage;
    }
    if (profilePath === 'philipmoyer') {
        image = philipMoyerAvatarImage;
    }
    if (profilePath === 'reidhoffman') {
        image = reidHoffmanAvatarImage;
    }
    if (profilePath === 'drcamillekandikohowson') {
        image = drCamilleKandikoHowsonAvatarImage;
    }
    if (profilePath === 'kathychen') {
        image = kathyChenAvatarImage;
    }
    if (profilePath === 'tierneymorgan') {
        image = tierneyMorganAvatarImage;
    }
    if (profilePath === 'bobgerard') {
        image = bobGerardAvatarImage;
    }

    if (profilePath === 'edosegal') {
        image = edoSegalAvatarImage;
    }

    if (profilePath === 'john-samuel') {
        image = johnSamuelAvatarImage;
    }

    if (profilePath === 'isabella-wong') {
        image = isabellaWongAvatarImage;
    }

    if (profilePath === 'sophia-martinez') {
        image = sophiaMartinezAvatarImage;
    }

    if (profilePath === 'ethan-lawson') {
        image = ethanLawsonAvatarImage;
    }

    if (profilePath === 'susangoodyer') {
        image = susanGoodyerAvatarImage;
    }

    if (profilePath === 'bartclarysse') {
        image = bartClarysseAvatarImage;
    }

    if (profilePath === 'omarmerlo') {
        image = omarMerloAvatarImage;
    }

    if (profilePath === 'markkennedy') {
        image = markKennedyAvatarImage;
    }

    const postClick = (index: number) => {
        //const exampleQns = posts[index]?.sample_qns ? posts[index]?.sample_qns : suggestedQuestions;
        const sampleQns = posts[index]?.sample_qns
            ? posts[index]?.sample_qns
            : suggestedQuestions;
        const count = Math.min(4, sampleQns.length); // Get 4 or fewer items based on availability
        const randomQns = getRandomElements(sampleQns, count);
        dispatch(setSuggestedQuestions(randomQns));
        dispatch(resetAnswers([]));
        setSummary(posts[index]?.summary ? posts[index]?.summary : "");
        setSummaryId(posts[index]?.summary ? index : "");
        if (posts[index]?.summary) {
            dispatch(setSummaryToTalk(posts[index]?.summary));
        }
        dispatch(setGenerating("summary-" + index));
    };

    function getRandomElements(arr: any, count: number) {
        let shuffled = arr.slice(0),
            i = arr.length,
            min = i - count,
            temp,
            index;
        while (i-- > min) {
            index = Math.floor((i + 1) * Math.random());
            temp = shuffled[i];
            shuffled[i] = shuffled[index];
            shuffled[index] = temp;
        }
        return shuffled.slice(min);
    }

    function handleRightSidebar() {
        if (!rightSidebarOpen) {
            setRightSidebarOpen(true);
        } else {
            setRightSidebarOpen(false);
        }
    }

    const isFromOrgLandingPage = (window as any).isFromOrgLandingPage ? (window as any).isFromOrgLandingPage : '0';

    return (
        <>
            <ToastContainer hideProgressBar={true}/>

            <div className="tc-social-wrapper">
                <div
                    className={`tc-social-container ${
                        rightSidebarOpen ? "open-hamburger" : ""
                    }`}
                >
                    <div className="tc-social-left-container">
                        {/*<div className="tc-socal-header-logo">
                                <img src={logoBlack} alt=""/>
                            </div>*/}
                        {/*<div className="tc-social-left-menu-wrapper">
                                <a href="#">
                                    <div className="tc-social-menu-item-wrapper">
                                        <span className='tc-left-menu-icon'>
                                            <svg viewBox="0 0 24 24">
                                                <g>
                                                    <path
                                                        d="M21.591 7.146L12.52 1.157c-.316-.21-.724-.21-1.04 0l-9.071 5.99c-.26.173-.409.456-.409.757v13.183c0 .502.418.913.929.913h6.638c.511 0 .929-.41.929-.913v-7.075h3.008v7.075c0 .502.418.913.929.913h6.639c.51 0 .928-.41.928-.913V7.904c0-.301-.158-.584-.408-.758zM20 20l-4.5.01.011-7.097c0-.502-.418-.913-.928-.913H9.44c-.511 0-.929.41-.929.913L8.5 20H4V8.773l8.011-5.342L20 8.764z"/>
                                                </g>
                                            </svg>
                                        </span>
                                        <span className='tc-left-menu-title'>Home</span>
                                    </div>

                                </a>
                                <a href="#">
                                    <div className="tc-social-menu-item-wrapper">
                                        <span className='tc-left-menu-icon'>
                                            <svg
                                                viewBox="0 0 24 24"
                                                aria-hidden="true"
                                                className="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-18jsvk2 r-lwhw9o r-cnnz9e"
                                            >
                                                <g>
                                                    <path
                                                        d="M10.25 3.75c-3.59 0-6.5 2.91-6.5 6.5s2.91 6.5 6.5 6.5c1.795 0 3.419-.726 4.596-1.904 1.178-1.177 1.904-2.801 1.904-4.596 0-3.59-2.91-6.5-6.5-6.5zm-8.5 6.5c0-4.694 3.806-8.5 8.5-8.5s8.5 3.806 8.5 8.5c0 1.986-.682 3.815-1.824 5.262l4.781 4.781-1.414 1.414-4.781-4.781c-1.447 1.142-3.276 1.824-5.262 1.824-4.694 0-8.5-3.806-8.5-8.5z"/>
                                                </g>
                                            </svg>
                                        </span>
                                        <span className='tc-left-menu-title'>Explore</span>
                                    </div>

                                </a>

                                <a href="#">
                                    <div className="tc-social-menu-item-wrapper">
                                        <span className='tc-left-menu-icon'>
                                            <svg
                                                viewBox="0 0 24 24"
                                                aria-hidden="true"
                                                className="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-18jsvk2 r-lwhw9o r-cnnz9e"
                                            >
                                                <g>
                                                    <path
                                                        d="M19.993 9.042C19.48 5.017 16.054 2 11.996 2s-7.49 3.021-7.999 7.051L2.866 18H7.1c.463 2.282 2.481 4 4.9 4s4.437-1.718 4.9-4h4.236l-1.143-8.958zM12 20c-1.306 0-2.417-.835-2.829-2h5.658c-.412 1.165-1.523 2-2.829 2zm-6.866-4l.847-6.698C6.364 6.272 8.941 4 11.996 4s5.627 2.268 6.013 5.295L18.864 16H5.134z"/>
                                                </g>
                                            </svg>
                                        </span>
                                        <span className='tc-left-menu-title'>Notification</span>
                                    </div>

                                </a>
                                <a href="#">
                                    <div className="tc-social-menu-item-wrapper">
                                        <span className='tc-left-menu-icon'>
                                            <svg
                                                viewBox="0 0 24 24"
                                                aria-hidden="true"
                                                className="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-18jsvk2 r-lwhw9o r-cnnz9e"
                                            >
                                                <g>
                                                    <path
                                                        d="M1.998 5.5c0-1.381 1.119-2.5 2.5-2.5h15c1.381 0 2.5 1.119 2.5 2.5v13c0 1.381-1.119 2.5-2.5 2.5h-15c-1.381 0-2.5-1.119-2.5-2.5v-13zm2.5-.5c-.276 0-.5.224-.5.5v2.764l8 3.638 8-3.636V5.5c0-.276-.224-.5-.5-.5h-15zm15.5 5.463l-8 3.636-8-3.638V18.5c0 .276.224.5.5.5h15c.276 0 .5-.224.5-.5v-8.037z"/>
                                                </g>
                                            </svg>
                                        </span>
                                        <span className='tc-left-menu-title'>Messages</span>
                                    </div>

                                </a>
                            </div>*/}
                        <div className="tc-social-user-meta-details">
                            <div className="tc-social-user-details">
                                <div className="tc-social-user-img-video">
                                    {/* <img src="//pbs.twimg.com/profile_images/1532405179009716226/CgIPmeYl_200x200.jpg" alt="" /> */}
                                    <Stream
                                        stream={streamData}
                                        sendDataToSocket={sendDataToSocket}
                                        key={streamData.index}
                                    />
                                </div>
                            </div>

                            <div className="tc-social-user-meta-details-wrapper">
                                <div className="tc-social-user-name">
                                    {name}
                                </div>
                                <div className="tc-social-user-handle">
                                    @{profileUsername}
                                </div>

                                {userDetails.meta_desc && (
                                    <div className="tc-social-user-meta-desc">
                                        {userDetails.meta_desc}
                                    </div>
                                )}
                                {/* {userDetails.meta_desc_handles && <div
                                    className="tc-social-user-meta-desc-handles">{userDetails.meta_desc_handles}</div>}
                                {userDetails.meta_desc_subscribe_link &&
                                    <div className="tc-social-user-meta-desc-subscribe">Subscribe: <a
                                        href={userDetails.meta_desc_subscribe_link}
                                        target="_blank">{userDetails.meta_desc_subscribe_link.replaceAll("https://", "")}</a>
                                    </div>} */}
                                <div className="tc-social-user-follow">
                                    {/*<a href="#" className="tc-social-three-dot-icon" onClick={openLightbox}>
                                            <svg
                                                viewBox="0 0 24 24"
                                                aria-hidden="true"
                                                className="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-z80fyv r-19wmn03"
                                                style={{color: "rgb(15, 20, 25)"}}
                                            >
                                                <g>
                                                    <path
                                                        d="M3 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm9 2c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm7 0c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/>
                                                </g>
                                            </svg>
                                        </a>

                                        <a href="#" className="tc-social-email-icon" onClick={openLightbox}>
                                            <svg
                                                viewBox="0 0 24 24"
                                                aria-hidden="true"
                                                className="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-z80fyv r-19wmn03"
                                                style={{color: "rgb(15, 20, 25)"}}
                                            >
                                                <g>
                                                    <path
                                                        d="M1.998 5.5c0-1.381 1.119-2.5 2.5-2.5h15c1.381 0 2.5 1.119 2.5 2.5v13c0 1.381-1.119 2.5-2.5 2.5h-15c-1.381 0-2.5-1.119-2.5-2.5v-13zm2.5-.5c-.276 0-.5.224-.5.5v2.764l8 3.638 8-3.636V5.5c0-.276-.224-.5-.5-.5h-15zm15.5 5.463l-8 3.636-8-3.638V18.5c0 .276.224.5.5.5h15c.276 0 .5-.224.5-.5v-8.037z"/>
                                                </g>
                                            </svg>
                                        </a>*/}
                                    {!isAccentureTwin(profilePath) &&
                                        <a
                                            href="#"
                                            className="tc-social-follow-btn"
                                            onClick={openLightbox}
                                        >
                                            Follow
                                        </a>
                                    }
                                </div>
                            </div>

                            {/* <div className="tc-social-meta-other-details">
                                {userDetails.location && <div className="tc-social-meta-other-item">
                                    <div className="tc-social-meta-other-item-icon">
                                        <svg
                                            viewBox="0 0 24 24"
                                            aria-hidden="true"
                                            className="r-4qtqp9 r-yyyyoo r-1xvli5t r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-14j79pv r-1d4mawv"
                                        >
                                            <g>
                                                <path
                                                    d="M12 7c-1.93 0-3.5 1.57-3.5 3.5S10.07 14 12 14s3.5-1.57 3.5-3.5S13.93 7 12 7zm0 5c-.827 0-1.5-.673-1.5-1.5S11.173 9 12 9s1.5.673 1.5 1.5S12.827 12 12 12zm0-10c-4.687 0-8.5 3.813-8.5 8.5 0 5.967 7.621 11.116 7.945 11.332l.555.37.555-.37c.324-.216 7.945-5.365 7.945-11.332C20.5 5.813 16.687 2 12 2zm0 17.77c-1.665-1.241-6.5-5.196-6.5-9.27C5.5 6.916 8.416 4 12 4s6.5 2.916 6.5 6.5c0 4.073-4.835 8.028-6.5 9.27z"/>
                                            </g>
                                        </svg>
                                    </div>
                                    <div className="tc-social-meta-other-item-title">{userDetails.location}</div>
                                </div>}

                                {userDetails.link_title && <div className="tc-social-meta-other-item">
                                    <div className="tc-social-meta-other-item-icon">
                                        <svg
                                            viewBox="0 0 24 24"
                                            aria-hidden="true"
                                            className="r-4qtqp9 r-yyyyoo r-1xvli5t r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-14j79pv r-1d4mawv"
                                        >
                                            <g>
                                                <path
                                                    d="M18.36 5.64c-1.95-1.96-5.11-1.96-7.07 0L9.88 7.05 8.46 5.64l1.42-1.42c2.73-2.73 7.16-2.73 9.9 0 2.73 2.74 2.73 7.17 0 9.9l-1.42 1.42-1.41-1.42 1.41-1.41c1.96-1.96 1.96-5.12 0-7.07zm-2.12 3.53l-7.07 7.07-1.41-1.41 7.07-7.07 1.41 1.41zm-12.02.71l1.42-1.42 1.41 1.42-1.41 1.41c-1.96 1.96-1.96 5.12 0 7.07 1.95 1.96 5.11 1.96 7.07 0l1.41-1.41 1.42 1.41-1.42 1.42c-2.73 2.73-7.16 2.73-9.9 0-2.73-2.74-2.73-7.17 0-9.9z"/>
                                            </g>
                                        </svg>
                                    </div>
                                    <div className="tc-social-meta-other-item-title"><a
                                        href={userDetails.link ? userDetails.link : ''}
                                        target="_blank">{userDetails.link_title}</a>
                                    </div>
                                </div>}

                                {userDetails.event && <div className="tc-social-meta-other-item">
                                    <div className="tc-social-meta-other-item-icon">
                                        <svg
                                            viewBox="0 0 24 24"
                                            aria-hidden="true"
                                            className="r-4qtqp9 r-yyyyoo r-1xvli5t r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-14j79pv r-1d4mawv"
                                        >
                                            <g>
                                                <path
                                                    d="M7 4V3h2v1h6V3h2v1h1.5C19.89 4 21 5.12 21 6.5v12c0 1.38-1.11 2.5-2.5 2.5h-13C4.12 21 3 19.88 3 18.5v-12C3 5.12 4.12 4 5.5 4H7zm0 2H5.5c-.27 0-.5.22-.5.5v12c0 .28.23.5.5.5h13c.28 0 .5-.22.5-.5v-12c0-.28-.22-.5-.5-.5H17v1h-2V6H9v1H7V6zm0 6h2v-2H7v2zm0 4h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm4-4h2v-2h-2v2z"/>
                                            </g>
                                        </svg>
                                    </div>
                                    <div className="tc-social-meta-other-item-title">{userDetails.event}</div>
                                </div>}
                            </div> */}

                            {/*<div className="tc-social-meta-other-details">
                                    <div className="tc-social-meta-other-item">
                                        <div className="tc-social-meta-other-item-title-bold">6,411</div>
                                        <div className="tc-social-meta-other-item-title">Following</div>
                                    </div>

                                    <div className="tc-social-meta-other-item">
                                        <div className="tc-social-meta-other-item-title-bold">20K</div>
                                        <div className="tc-social-meta-other-item-title">Followers</div>
                                    </div>

                                </div>*/}
                        </div>
                        <Scrollbars className="tc-social-right-container">

                            <div className="tc-social-hamburger-bg"></div>
                            {isAccentureTwin(profilePath) &&
                                <div className={"tc-social-bio"}>
                                    {bio}
                                </div>
                            }


                            {posts.map((post: any, index: number) => {
                                postVideoRefs[index] =
                                    React.createRef<HTMLVideoElement>();
                                return (
                                    <div
                                        className="tc-social-main-post-wrapper"
                                        onClick={() => postClick(index)}
                                        key={"posts-" + index}
                                    >
                                        <div className="tc-social-main-post-container">
                                            {/*<div className="tc-social-main-post-left">
                                                    <div className="tc-social-main-post-user-avatar">
                                                        <img src={post.avatar} alt=""/>
                                                    </div>
                                                </div>*/}
                                            <div className="tc-social-main-post-right">
                                                {/* <div className="tc-social-main-post-user-details">
                                                    <div
                                                        className="tc-social-main-post-username">{name}</div>
                                                    <div
                                                        className="tc-social-main-post-user-handle">@{profileUsername}</div>
                                                    <div className="tc-social-main-post-user-divider">·</div>
                                                    <div
                                                        className="tc-social-main-post-user-date">{post.date}</div>
                                                </div> */}

                                                {/* <div className="tc-social-main-post-desc"
                                                     dangerouslySetInnerHTML={{__html: post.description}}></div> */}

                                                <div className="tc-social-mian-post-img">
                                                    <div
                                                        className={`tc-social-img-wrapper ${
                                                            playIndex ===
                                                            index &&
                                                            playing === true
                                                                ? "play"
                                                                : "pause"
                                                        } `}
                                                    >
                                                        {
                                                            <img
                                                                className="post-video-thumbnail"
                                                                src={
                                                                    post.thumbnail
                                                                }
                                                                alt=""
                                                            />
                                                        }
                                                        {/* <video
                                                            key={
                                                                "post-video-ref-" +
                                                                index
                                                            }
                                                            id={`post-video-ref-${index}`}
                                                            className="post-video"
                                                            ref={
                                                                postVideoRefs[
                                                                    index
                                                                    ]
                                                            }
                                                            src={post.video_url}
                                                            playsInline={true}
                                                            webkit-playsinline="true"
                                                        /> */}
                                                        <a
                                                            ref={playBtnRef}
                                                            id={`post-video-play-ref-${index}`}
                                                            href="#"
                                                            className="playbtn"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                playVideo(
                                                                    index
                                                                );
                                                            }}
                                                        >
                                                            <img
                                                                src={playBtn}
                                                                alt=""
                                                            />
                                                        </a>
                                                        <a
                                                            ref={pauseBtnRef}
                                                            id={`post-video-pause-ref-${index}`}
                                                            href="#"
                                                            className="pausebtn"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                playVideo(
                                                                    index
                                                                );
                                                            }}
                                                        >
                                                            <img
                                                                src={pauseBtn}
                                                                alt=""
                                                            />
                                                        </a>

                                                        <div
                                                            className="tc-social-img-bottom-title"
                                                            dangerouslySetInnerHTML={{
                                                                __html: post.description,
                                                            }}
                                                        ></div>
                                                    </div>
                                                    {/* <div className="tc-social-img-site">
                                                        {userDetails.post_from_text && <a href={post.link}
                                                                                          target="_blank">{userDetails.post_from_text}</a>}
                                                    </div> */}
                                                </div>

                                                {/*<div className="tc-social-main-post-action-wrapper">
                                                        <div className="tc-social-main-post-action-item">
                                                            <a href="#" className='tc-social-comment-icon'
                                                               onClick={openLightbox}>
                                                                <div className="tc-social-action-icon">
                                                                    <svg
                                                                        viewBox="0 0 24 24"
                                                                        aria-hidden="true"
                                                                        className="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-1xvli5t r-1hdv0qi"
                                                                    >
                                                                        <g>
                                                                            <path
                                                                                d="M1.751 10c0-4.42 3.584-8 8.005-8h4.366c4.49 0 8.129 3.64 8.129 8.13 0 2.96-1.607 5.68-4.196 7.11l-8.054 4.46v-3.69h-.067c-4.49.1-8.183-3.51-8.183-8.01zm8.005-6c-3.317 0-6.005 2.69-6.005 6 0 3.37 2.77 6.08 6.138 6.01l.351-.01h1.761v2.3l5.087-2.81c1.951-1.08 3.163-3.13 3.163-5.36 0-3.39-2.744-6.13-6.129-6.13H9.756z"/>
                                                                        </g>
                                                                    </svg>
                                                                </div>
                                                                <div className="tc-social-icon-value">8</div>
                                                            </a>
                                                            <a href="#" className='tc-social-repost-icon'
                                                               onClick={openLightbox}>
                                                                <div className="tc-social-action-icon">
                                                                    <svg
                                                                        viewBox="0 0 24 24"
                                                                        aria-hidden="true"
                                                                        className="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-1xvli5t r-1hdv0qi"
                                                                    >
                                                                        <g>
                                                                            <path
                                                                                d="M4.5 3.88l4.432 4.14-1.364 1.46L5.5 7.55V16c0 1.1.896 2 2 2H13v2H7.5c-2.209 0-4-1.79-4-4V7.55L1.432 9.48.068 8.02 4.5 3.88zM16.5 6H11V4h5.5c2.209 0 4 1.79 4 4v8.45l2.068-1.93 1.364 1.46-4.432 4.14-4.432-4.14 1.364-1.46 2.068 1.93V8c0-1.1-.896-2-2-2z"/>
                                                                        </g>
                                                                    </svg>
                                                                </div>
                                                                <div className="tc-social-icon-value">8</div>
                                                            </a>

                                                            <a href="#" className='tc-social-like-icon'
                                                               onClick={openLightbox}>
                                                                <div className="tc-social-action-icon">
                                                                    <svg
                                                                        viewBox="0 0 24 24"
                                                                        aria-hidden="true"
                                                                        className="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-1xvli5t r-1hdv0qi"
                                                                    >
                                                                        <g>
                                                                            <path
                                                                                d="M16.697 5.5c-1.222-.06-2.679.51-3.89 2.16l-.805 1.09-.806-1.09C9.984 6.01 8.526 5.44 7.304 5.5c-1.243.07-2.349.78-2.91 1.91-.552 1.12-.633 2.78.479 4.82 1.074 1.97 3.257 4.27 7.129 6.61 3.87-2.34 6.052-4.64 7.126-6.61 1.111-2.04 1.03-3.7.477-4.82-.561-1.13-1.666-1.84-2.908-1.91zm4.187 7.69c-1.351 2.48-4.001 5.12-8.379 7.67l-.503.3-.504-.3c-4.379-2.55-7.029-5.19-8.382-7.67-1.36-2.5-1.41-4.86-.514-6.67.887-1.79 2.647-2.91 4.601-3.01 1.651-.09 3.368.56 4.798 2.01 1.429-1.45 3.146-2.1 4.796-2.01 1.954.1 3.714 1.22 4.601 3.01.896 1.81.846 4.17-.514 6.67z"/>
                                                                        </g>
                                                                    </svg>
                                                                </div>
                                                                <div className="tc-social-icon-value">8</div>
                                                            </a>

                                                            <a href="#" className='tc-social-view-icon'
                                                               onClick={openLightbox}>
                                                                <div className="tc-social-action-icon">
                                                                    <svg
                                                                        viewBox="0 0 24 24"
                                                                        aria-hidden="true"
                                                                        className="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-1xvli5t r-1hdv0qi"
                                                                    >
                                                                        <g>
                                                                            <path
                                                                                d="M8.75 21V3h2v18h-2zM18 21V8.5h2V21h-2zM4 21l.004-10h2L6 21H4zm9.248 0v-7h2v7h-2z"/>
                                                                        </g>
                                                                    </svg>
                                                                </div>
                                                                <div className="tc-social-icon-value">8</div>
                                                            </a>

                                                            <a href="#" className='tc-social-bookmark-icon'
                                                               onClick={openLightbox}>
                                                                <div className="tc-social-action-icon">
                                                                    <svg
                                                                        viewBox="0 0 24 24"
                                                                        aria-hidden="true"
                                                                        className="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-1xvli5t r-1hdv0qi"
                                                                    >
                                                                        <g>
                                                                            <path
                                                                                d="M4 4.5C4 3.12 5.119 2 6.5 2h11C18.881 2 20 3.12 20 4.5v18.44l-8-5.71-8 5.71V4.5zM6.5 4c-.276 0-.5.22-.5.5v14.56l6-4.29 6 4.29V4.5c0-.28-.224-.5-.5-.5h-11z"/>
                                                                        </g>
                                                                    </svg>
                                                                </div>
                                                            </a>

                                                            <a href="#" className='tc-social-share-icon'
                                                               onClick={openLightbox}>
                                                                <div className="tc-social-action-icon">
                                                                    <svg
                                                                        viewBox="0 0 24 24"
                                                                        aria-hidden="true"
                                                                        className="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-1xvli5t r-1hdv0qi"
                                                                    >
                                                                        <g>
                                                                            <path
                                                                                d="M12 2.59l5.7 5.7-1.41 1.42L13 6.41V16h-2V6.41l-3.3 3.3-1.41-1.42L12 2.59zM21 15l-.02 3.51c0 1.38-1.12 2.49-2.5 2.49H5.5C4.11 21 3 19.88 3 18.5V15h2v3.5c0 .28.22.5.5.5h12.98c.28 0 .5-.22.5-.5L19 15h2z"/>
                                                                        </g>
                                                                    </svg>
                                                                </div>
                                                            </a>

                                                        </div>
                                                    </div>*/}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}

                        </Scrollbars>
                    </div>
                    <div className="tc-social-middle-right-wrapper">
                        <div className="tc-social-middle-container">
                            <div className="tc-social-post-wrapper">
                                <div className="tc-social-post-container">
                                    {/*<div className="tc-social-tab-container">
                                            <ul>
                                                <li>
                                                    <a href="#" className='active'><span>Post</span></a>
                                                </li>
                                                <li>
                                                    <a href="#" onClick={openLightbox}><span>Replies</span></a>
                                                </li>
                                                <li>
                                                    <a href="#" onClick={openLightbox}><span>Media</span></a>
                                                </li>
                                                <li>
                                                    <a href="#" onClick={openLightbox}><span>Likes</span></a>
                                                </li>
                                            </ul>
                                        </div>*/}
                                </div>
                            </div>
                            {showExperience && chatAnswers.length === 0 && (
                                <div className="tc-chat-welcome-screen">
                                    <div className="tc-chat-welcome-msg">
                                        <ChatAnimation
                                            key={
                                                summary !== ""
                                                    ? "summary_" + summaryId
                                                    : "welcome"
                                            }
                                            identifier="welcome"
                                            chatAnswer={
                                                summary !== ""
                                                    ? summary
                                                    : welcome
                                            }
                                            initialDelay={
                                                window.chatOnly ? 0 : 3
                                            }
                                            wordDelay={0.2}
                                            classNameBeforeDelay={
                                                "tc-type-animation-thinking"
                                            }
                                            classNameAfterDelay={""}
                                        />
                                    </div>
                                </div>
                            )}

                            {isChatMode && chatAnswers.length !== 0 && (
                                <Scrollbars
                                    className="tc-social-scrollbar"
                                    style={{minHeight: isFromOrgLandingPage === '1' ? "calc(100vh - 70px)" : "100vh"}}
                                >
                                    <div className="tc-main-container">
                                        <div
                                            className={
                                                showExperience
                                                    ? "tc-chat-wrapper"
                                                    : "launch tc-chat-wrapper"
                                            }
                                        >
                                            <div
                                                className="tc-chat-container"
                                                id="tc-chat-container"
                                            >
                                                <Chat/>
                                            </div>
                                        </div>
                                    </div>
                                </Scrollbars>
                            )}
                        </div>
                        <div
                            className="tc-social-mob-hamburger"
                            onClick={handleRightSidebar}
                        >
                            <div className="tc-social-mob-hamburger-icon">
                                <svg
                                    width="30px"
                                    height="30px"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M20 7L4 7"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        d="M20 12L4 12"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        d="M20 17L4 17"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <Question sendDataToSocket={sendDataToSocket}/>
                {/* Lightbox for invite email */}
                <div
                    className={`tc-social-lightbox-wrapper ${
                        openModel ? "open" : ""
                    }`}
                >
                    <div className="tc-social-lightbox-container">
                        <div className="tc-social-lightbox-close-btn">
                            <a href="#" onClick={closeLightbox}>
                                <svg
                                    viewBox="0 0 24 24"
                                    aria-hidden="true"
                                    className="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-z80fyv r-19wmn03"
                                    style={{color: "rgb(15, 20, 25)"}}
                                >
                                    <g>
                                        <path
                                            d="M10.59 12L4.54 5.96l1.42-1.42L12 10.59l6.04-6.05 1.42 1.42L13.41 12l6.05 6.04-1.42 1.42L12 13.41l-6.04 6.05-1.42-1.42L10.59 12z"/>
                                    </g>
                                </svg>
                            </a>
                        </div>
                        {/* <h1>Request for invite</h1> */}
                        <div className="tc-social-login-form-wrapper">
                            <div className="tc-social-login-form-group">
                                <label htmlFor="txt-username">Username</label>
                                <input
                                    type="text"
                                    id="txt-username"
                                    name="txt-username"
                                    placeholder="Your Username Here"
                                />
                            </div>
                            <div className="tc-social-login-form-group">
                                <label htmlFor="txt-password">Password</label>
                                <input
                                    type="password"
                                    id="txt-password"
                                    name="txt-password"
                                    placeholder="Your Password Here"
                                />
                            </div>
                        </div>
                        <div className="tc-social-join-form-wrapper">
                            <label htmlFor="txt-password">
                                or request an invite
                            </label>
                            <div className="tc-social-join-wrapper">
                                <input
                                    type="email"
                                    onChange={(e) =>
                                        setWaitEmail(e.target.value)
                                    }
                                    name="txt-name"
                                    id="txt-name"
                                    placeholder="Your email"
                                />
                                <a
                                    href="#"
                                    className={`btn-social-join ${
                                        emailCheck.test(waitEmail)
                                            ? ""
                                            : "disabled-join"
                                    }`}
                                    onClick={submitWaitingList}
                                >
                                    Request
                                </a>
                            </div>
                        </div>
                        <div className="tc-social-join-form-video">
                            <iframe
                                src="https://tc.touchcast.com/s/qcgjlr2gsk"
                                width="100%"
                                height="100%"
                                frameBorder="0"
                                allowFullScreen={true}
                            />
                        </div>
                        <div className="tc-social-learnmore">
                            Learn more at{" "}
                            <a href="#" target="_blank">
                                Genything.ai
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            {!showExperience && (
                <Launch
                    stream={streamData}
                    sendDataToSocket={sendDataToSocket}
                />
            )}

            <div
                className={`tc-social-video-lightbox-wrapper ${(playIndex !== null && playing === true) ? 'open fade-in-div' : 'fade-out-div'}`}>
                <div className="tc-social-video-lightbox-container">
                    <div className="tc-social-video-lightbox-close-btn">
                        <a onClick={closeVideo} href="#">
                            <svg
                                viewBox="0 0 24 24"
                                aria-hidden="true"
                                className="r-4qtqp9 r-yyyyoo r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-z80fyv r-19wmn03"
                                style={{color: "rgb(15, 20, 25)"}}
                            >
                                <g>
                                    <path
                                        d="M10.59 12L4.54 5.96l1.42-1.42L12 10.59l6.04-6.05 1.42 1.42L13.41 12l6.05 6.04-1.42 1.42L12 13.41l-6.04 6.05-1.42-1.42L10.59 12z"/>
                                </g>
                            </svg>
                        </a>
                    </div>
                    <div className="tc-social-video-url">
                        {/* Pre loaded videos to avoid delay while play */}
                        {posts.map((post: any, index: number) => {
                                postVideoRefs[index] =
                                    React.createRef<HTMLVideoElement>();
                                return (
                                    <video
                                        key={
                                            "post-video-ref-" +
                                            index
                                        }
                                        id={`post-video-ref-${index}`}
                                        className={`post-video ${playIndex === index ? 'show-video' : 'hide-video'}`}
                                        ref={
                                            postVideoRefs[
                                                index
                                                ]
                                        }
                                        src={post.video_url}
                                        playsInline={true}
                                        webkit-playsinline="true"
                                        controls={true}
                                    />
                                );
                            }
                        )}

                    </div>
                </div>
            </div>
        </>
    );
};
